import { z } from "zod";

// Define the chat request schema
export const ChatRequestBodySchema = z.object({
  messages: z.array(
    z.object({
      role: z.enum(["user", "assistant", "system", "function", "tool"]),
      content: z.string().nullable().optional(),
      name: z.string().optional(),
      function_call: z.any().optional(),
      tool_calls: z.array(z.any()).optional(),
      tool_call_id: z.string().optional(),
      toolInvocations: z.array(z.any()).optional(),
    }),
  ),
  model: z.string().optional(),
  tools: z.array(z.any()).optional(),
  system: z.string().optional(),
  baseUrl: z.string().optional(),
});

export type ChatRequestBody = z.infer<typeof ChatRequestBodySchema>;

// Define event handlers for chat streaming
export interface ChatEventHandlers {
  onPartial?: (data: any) => void;
  onComplete?: (data: any) => void;
  onError?: (error: { error: string }) => void;
}
